var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAustralia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "AUSTRALIA_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_83308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000123402007188672039330000004463701757295784598_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.3091 0.824219H0.746094V20.4032H34.3091V0.824219Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_83308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.3091 0.824219H0.746094V20.4032H34.3091V0.824219Z",
    fill: "#180087"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_83308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000123402007188672039330000004463701757295784598__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.3091 0.824219H0.746094V20.4032H34.3091V0.824219Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_83308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.5722 12.8193L10.0882 14.4103L11.6462 13.8183L10.7272 15.2083L12.1582 16.0603L10.4982 16.2043L10.7272 17.8553L9.5722 16.6483L8.42816 17.8553L8.65619 16.2043L6.99219 16.0603L8.42816 15.2083L7.50421 13.8183L9.06616 14.4103L9.5722 12.8193Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_83308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000123402007188672039330000004463701757295784598__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34.3091 0.824219H0.746094V20.4032H34.3091V0.824219Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_83308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27.2309 15.6797L27.4789 16.4367L28.2209 16.1557L27.7829 16.8177L28.4649 17.2237L27.6699 17.2917L27.7829 18.0777L27.2309 17.5017L26.6879 18.0777L26.7969 17.2917L26.0059 17.2237L26.6879 16.8177L26.2499 16.1557L26.9919 16.4367L27.2309 15.6797Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_83308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000123402007188672039330000004463701757295784598__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M34.3091 0.824219H0.746094V20.4032H34.3091V0.824219Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_83308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M22.8198 8.68945L23.0628 9.44547L23.8048 9.16345L23.3668 9.82745L24.0488 10.2325L23.2578 10.2995L23.3668 11.0875L22.8198 10.5115L22.2708 11.0875L22.3808 10.2995L21.5898 10.2325L22.2708 9.82745L21.8338 9.16345L22.5758 9.44547L22.8198 8.68945Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_83308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000123402007188672039330000004463701757295784598__5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M34.3091 0.824219H0.746094V20.4032H34.3091V0.824219Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_83308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M27.2309 3.90625L27.4789 4.66324L28.2209 4.38324L27.7829 5.04324L28.4649 5.44925L27.6699 5.51924L27.7829 6.30424L27.2309 5.73024L26.6879 6.30424L26.7969 5.51924L26.0059 5.44925L26.6879 5.04324L26.2499 4.38324L26.9919 4.66324L27.2309 3.90625Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_83308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000123402007188672039330000004463701757295784598__6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M34.3091 0.824219H0.746094V20.4032H34.3091V0.824219Z",
    fill: "white"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_83308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M31.1597 7.51367L31.3997 8.26967L32.1477 7.98767L31.7047 8.64967L32.3907 9.05367L31.5957 9.12367L31.7087 9.91167L31.1597 9.33467L30.6127 9.91167L30.7227 9.12367L29.9297 9.05367L30.6127 8.64967L30.1757 7.98767L30.9177 8.26967L31.1597 7.51367Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_83308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000123402007188672039330000004463701757295784598__7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M34.3091 0.824219H0.746094V20.4032H34.3091V0.824219Z",
    fill: "white"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_83308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M28.9998 11.0547L29.1927 11.5257L29.6987 11.5637L29.3127 11.8917L29.4318 12.3867L28.9998 12.1167L28.5698 12.3867L28.6898 11.8917L28.3008 11.5637L28.8088 11.5257L28.9998 11.0547Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11472_83308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000123402007188672039330000004463701757295784598__8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M34.3091 0.824219H0.746094V20.4032H34.3091V0.824219Z",
    fill: "white"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11472_83308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M8.10614 0.824219V3.76921H0.746094V6.71222H8.10614V9.65521H11.0451V6.71222H18.4081V3.76921H11.0451V0.824219H8.10614Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11472_83308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000123402007188672039330000004463701757295784598__9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M34.3091 0.824219H0.746094V20.4032H34.3091V0.824219Z",
    fill: "white"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11472_83308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M0.746094 0.824219V1.81122L16.4321 9.65521H18.4041V8.66821L2.72113 0.824219H0.746094Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11472_83308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000123402007188672039330000004463701757295784598__10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M34.3091 0.824219H0.746094V20.4032H34.3091V0.824219Z",
    fill: "white"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11472_83308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M16.4321 0.824219L0.746094 8.66821V9.65521H2.72113L18.4041 1.81122V0.824219H16.4321Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11472_83308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000123402007188672039330000004463701757295784598__11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M34.3091 0.824219H0.746094V20.4032H34.3091V0.824219Z",
    fill: "white"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11472_83308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M8.6911 0.824219V4.35622H0.746094V6.12321H8.6911V9.65521H10.4571V6.12321H18.4041V4.35622H10.4571V0.824219H8.6911Z",
    fill: "#EA0020"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11472_83308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000123402007188672039330000004463701757295784598__12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M34.3091 0.824219H0.746094V20.4032H34.3091V0.824219Z",
    fill: "white"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11472_83308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M0.746094 0.824219V1.48322L5.31213 3.76822H6.63214L0.746094 0.824219ZM17.0881 0.824219L11.2031 3.76822H12.5191L18.4041 0.824219H17.0881Z",
    fill: "#EA0020"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11472_83308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000123402007188672039330000004463701757295784598__13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M34.3091 0.824219H0.746094V20.4032H34.3091V0.824219Z",
    fill: "white"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11472_83308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M6.63312 6.71191L0.746094 9.65491H2.06213L7.9491 6.71191H6.63312ZM12.5191 6.71191L18.4081 9.65491V8.9969L13.8361 6.71191H12.5191Z",
    fill: "#EA0020"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustralia);
export default __webpack_public_path__ + "static/media/AUSTRALIA.c7e23d04a27247bfd388cae1799c6d0f.svg";
export { ForwardRef as ReactComponent };